import React, { useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import SolutionsIcon from "../../assets/icons/componenets.svg2";
import LogicIcon from "../../assets/icons/library_logic.svg2";
import HelpButton from "../HelpContent/HelpButton";
import MyModal from "../Common/MyModal";
import ComponentLibrary from "../Library/ComponentLibrary";
import LogicTemplateLibrary from "../Library/LogicTemplateLibrary";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";

function BoomLogicDropdown() {
  const [show, setShow] = useState(false);
  return (
    <div>
      <Dropdown onToggle={setShow} show={show}>
        <button
          type="button"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setShow((p) => !p);
          }}
          className="btn btn-sm bg-purple-gradient rounded-3 text-purple text-small fw-bold w-100"
        >
          Start with a..
          <FontAwesomeIcon icon={faChevronDown} className="float-end mt-1" />
        </button>
        <Dropdown.Menu className="bg-purple-gradient">
          <Dropdown.Item>
            <MyModal
              size="xxl"
              label={
                <div className="d-flex align-items-center justify-content-between gap-3">
                  <div className="d-flex">
                    <SolutionsIcon width={30} />
                  </div>
                  <div>
                    <h5 className="fw-bold text-purple text-start">
                      Solutions{" "}
                    </h5>
                    <span className="text-secondary">
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    </span>
                  </div>
                  <HelpButton helpKey="solution-library" />
                </div>
              }
              buttonClassName=" rounded-4 start text-black border-0 "
              modalClassName="bg-purple-gradient"
            >
              <ComponentLibrary isModal />
            </MyModal>
          </Dropdown.Item>
          <hr className="m-0" />
          <Dropdown.Item>
            <MyModal
              size="xxl"
              label={
                <div className="d-flex align-items-center justify-content-between gap-3">
                  <div className="d-flex">
                    <LogicIcon width={30} />
                  </div>
                  <div>
                    <h5 className="fw-bold text-purple text-start">
                      Logic Library
                    </h5>
                    <span className="text-secondary">
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    </span>
                  </div>
                  <HelpButton helpKey="logic-library" />
                </div>
              }
              buttonClassName=" rounded-4 start text-black border-0 "
              modalClassName="bg-purple-gradient"
            >
              <LogicTemplateLibrary isModal />
            </MyModal>
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
}

export default BoomLogicDropdown;
